<template>
  <div class="profit-address" :class="{'isiOSX':isiOSX}">
    <van-nav-bar
      title="选择收货地址"
      left-arrow
      @click-left="reBack"
    />
    <div class="content">
      <van-row class="listAll" v-for="(item,index) in addressList" :key="index">
        <van-col span="24" class="list">
          <p class="name">{{item.realname}}
            <span>{{item.mobile}}</span>
          </p>
					<p class="addre">{{item.address_name}}{{item.detail_address}}</p>
	        <img
	          v-if="!item.selected"
	          @click="selectAddress(item)"
	          class="selectAddress"
	          src="../../assets/plane/noselect@2x.png"
	        />
	        <img
	          v-if="item.selected"
	          @click="selectAddress(item)"
	          class="selectAddress"
	          src="../../assets/plane/delected@2x.png"
	        />

        </van-col>
      </van-row>
      <div class="listAll loading">
	    	<img src="../../assets/common/loading.gif" v-if="addressList.length <= 0 && hasAddress"/>
	    </div>
	    <van-row class="empty_list" v-if="!hasAddress">
	      <van-col class="emptyMsg" span="24">
	        <img src="../../assets/plane/noOrder.png" />
	        <p class="tip1">暂无收货地址，请前往销巴生活APP"我的-设置-收货地址"填写！</p>
	        <p class="btn">
	          <span @click="reBack">返回</span>
	        </p>
	      </van-col>
	    </van-row>
    </div>
    <div class="btn-new">
      <van-button @click="determine" type="default" size="large" :style="btnBg">确定</van-button>
    </div>
  </div>
</template>
<script>
// import { log } from 'util';
import Bus from "../../providers/eventBus";
export default {
  data() {
    return {
      addressList: [],
      isiOSX: false,
      delectItem: {},
      show: false,
      hasAddress: true,
      btnBg: {background: '#D2D2D2'},
      selected: false,
      num:this.$route.query.active
    };
  },
 beforeDestroy() {
    Bus.$emit('busBigTurntableProfit', {tab:this.num})
  },

  methods: {
    reBack() {
      this.$router.go(-1);
    },
    //获取收货地址列表
    getInfoList() {
      this.$api
        .post("member/member/address/list")
        .then(res => {
        	if(res.list.length == 0) {
        		this.hasAddress = false;
        		this.addressList = [];
        		 return;
        	}
          this.addressList = res.list.map(item => {
            return {...item, ...{selected: false}}
          })
        })
        .catch(err => {
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
			    //this.$toast(message);
			    if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  		}else {
		  			this.$toast(message);
		  		}
        });
      // let res = [
      //   {
      //     realname: "收货人名字1",
      //     mobile: "123456712323",
      //     address_name: "大地名",
      //     detail_address: "详情地址",
      //   },
      //   {
      //     realname: "收货人名字1",
      //     mobile: "123456712323",
      //     address_name: "大地名",
      //     detail_address: "详情地址",
      //   },
      //   {
      //     realname: "收货人名字1",
      //     mobile: "123456712323",
      //     address_name: "大地名",
      //     detail_address: "详情地址",
      //   },
      // ]
    },
    selectAddress(item) {
      this.addressList.forEach(item => {
        item.selected = false
      })
      item.selected = true
    	this.btnBg.background = '#FF7300';
    	this.selected = true;
    },
    determine() {
    	if(this.selected) {
        let selectedAddress = {}
        this.addressList.forEach(item => {
          if (item.selected) {
            selectedAddress = item
            return
          }
        })
        const param = {
          record_id: this.$route.query.record_id,
          consignee: selectedAddress.realname,
          member_mobile: selectedAddress.mobile,
          address: `${selectedAddress.address_name} ${selectedAddress.detail_address}`
        }
        this.$api.post('/activity/member/turntable/express/edit', param)
        .then(res => {
          this.$router.go(-1);
          this.$toast('地址已上传，等待审核')
        })
        .catch(()=>{

        })
    	}else {
    		this.$toast('请选择您的收货地址');
    	}
      
    }
  },
  mounted() {
  	this.isiOSX = this.isIphoneX();
    this.getInfoList();
  }
};
</script>
<style lang="less">
.profit {
  &-address {
    height: 100%;
    // background: #F2F2F2;
    .van-nav-bar {
      background: #fff;
      padding-top: 24px;
      position: fixed;
      top: 0;
      width: 100%;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333;
      }
      .van-nav-bar__text {
        color: #333;
        font-size: 14px;
      }
      .van-icon-arrow-left:before {
        display: none;
      }
      .van-nav-bar__left {
        left: 11px;
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .content {
    	// padding-left: 50px;
      position: relative;
      background: #fff;
			margin-top: 66px;
			.van-popup--center{
				width: 70%;
				border-radius: 10px;
				.box {
					img {
						display: block;
						width: 100%;
					}
					.title {
						color: #333;
						font-size: 15px;
						font-weight: 600;
						line-height: 47px;
						margin-top: 8px;
						text-align: center;
					}
					.tips {
						color: #333;
						font-size: 13px;
						line-height: 18px;
						text-align: center;
						margin-bottom: 30px;
					}
					span {
						float: left;
						width: 50%;
						border-top: solid 1px #F2F2F2;
						line-height: 43px;
						color: #999;
						font-size: 14px;
						text-align: center;
						display: inline-block;
					}
					.right {
						color: #E6212F;
						width: calc(50% - 1px);
						border-left: solid 1px #F2F2F2;
					}
				}
      }
      
      .listAll {
        padding-left: 50px;  //解决收货地址列表页面图片不居中问题
        .list {
          background: #fff;
          box-shadow: #efefef 1px 0 3px;
          padding:8px 16px 16px 0;
          position: relative;
          .name {
          	height: 40px;
          	line-height: 40px;
	          color: #1D1E1F;
	          font-size: 17px;
	          font-weight: bold;
	          span {
	          	color: #999999;
	          	margin-left: 12px;
	          }
	        }
	        .addre {
	        	color: #999;
	        	font-size: 14px;
	        	height: 40px;
	        	line-height: 20px;
	        }
	        .selectAddress {
	        	width: 18px;
	        	position: absolute;
	        	top: 43px;
	        	left: -34px;
	        }
        }
      }
      .loading{
        text-align: center;
        padding-left: 0px;
	    	img {
	    		width: 35%;
	    		margin-top: 50%;
	    	}
	    }
	    .empty_list {
	      padding-top: 66px;
	      .emptyMsg {
	        padding: 0 93px;
	        text-align: center;
	        img {
            padding-right: 50px;
	          width: 100%;
	          display: block;
	        }
	        .tip1 {
	          color: #b9b9b9;
	          font-size: 15px;
	          height: 24px;
	          line-height: 24px;
            margin-bottom: 12px;
            margin-top: 27px;
	        }
	        .btn {
            text-align: center;
            margin-top: 100px;
	          span {
	            width: 110px;
	            height: 32px;
	            line-height: 32px;
	            color: #ff6059;
	            display: inline-block;
	            border: solid 1px rgba(255, 96, 89, 0.4);
	            border-radius: 16px;
	            box-shadow: rgba(255, 96, 89, 0.1) 3px 0 6px;
	          }
	        }
	      }
	    }
    }
    .btn-new {
      box-sizing: border-box;
      position: fixed;
      bottom: 0px;
      width: 100%;
      .van-button--large {
      	color: #fff;
        height: 34px;
        font-size: 18px;
        font-weight: bold;
        height: 50px;
        line-height: 50px;
      }
    }
  }
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.content {
		padding-top: 90px;
		margin-top: 0;
	}
}
</style>